import { useTranslation } from "react-i18next";
import { Badge } from "@nexus/ui";
import type { ScheduledJobState } from "@/features/scheduled-jobs/api/scheduled-jobs.api";

const STATE_VARIANT: Record<
  ScheduledJobState,
  "status-delivered" | "status-error" | "status-in-production" | "slate"
> = {
  ENABLED: "status-delivered",
  PAUSED: "status-in-production",
  DISABLED: "slate",
  UPDATE_FAILED: "status-error",
  UNKNOWN: "slate",
};

const STATE_LABEL_FALLBACK: Record<ScheduledJobState, string> = {
  ENABLED: "Enabled",
  PAUSED: "Paused",
  DISABLED: "Disabled",
  UPDATE_FAILED: "Update failed",
  UNKNOWN: "Unknown",
};

export function ScheduledJobStateBadge({ state }: { state: ScheduledJobState }) {
  const { t } = useTranslation();

  return (
    <Badge variant={STATE_VARIANT[state]} dot>
      {t(`admin.scheduledJobs.state.${state}`, STATE_LABEL_FALLBACK[state])}
    </Badge>
  );
}
